import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { FormSubmission } from '../../../types/FormSubmission';

const fetchFormSubmission = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;

  const response = await CustomAxios.get<FormSubmission>(`form_submissions/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetFormSubmissionByIdProps {
  uuid?: string;
}

export function useGetFormSubmissionById({ uuid }: UseGetFormSubmissionByIdProps) {
  return useQuery({
    queryKey: [queryKeys.allFormSubmissions, uuid],
    queryFn: () => fetchFormSubmission(uuid),
  });
}
